import { Button } from '@mui/material'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import useMosInfo from './provider/useMosInfo'

const WorkerRequiredButton = (props) => {
  const { worker, requestWorker, globalData } = useMosInfo()
  const { onClick, sx } = props
  const [errorWorker, setErrorWorker] = useState(false)

  useEffect(() => {
    if (!globalData.workerRequested) {
      setErrorWorker(false)
    }
  }, [globalData?.workerRequested])

  const internalOnClick = useCallback((event) => {
    if (!worker) {
      requestWorker()
      setErrorWorker(true)
      return
    }
    onClick()
  }, [onClick, worker, requestWorker])

  const finalSX = useMemo(() => {
    const result = sx || {}
    if (!worker && !errorWorker) {
      return { ...sx, opacity: 0.5 }
    }
    return result
  }, [sx, worker, errorWorker])

  const finalProps = errorWorker
    ? { ...props, children: 'Worker required', color: 'error' }
    : props

  return (
    <Button {...finalProps} sx={finalSX} onClick={internalOnClick} />
  )
}

export default WorkerRequiredButton
